import {environmentBase} from './environment_base';

let environment;

if (process.env.NODE_ENV == 'production') {
  environment = Object.assign({}, environmentBase, {
    production: true,
  });
}
else {
  environment = Object.assign({}, environmentBase, {
    production: false,
  });
}

export default environment;


// WEBPACK FOOTER //
// ./environments/environment.js